export default function ExbtPlcTab({ exbtPlcHandler, selectedExbtPlcList, evntList }: any) {
    const noEvntMsg = '당일 행사가\n없습니다.'

    const getPlaceNameProperties = (hallName: string) => {
        return `w-[90%] mt-15 border rounded-[7px] md:rounded-[17px] flex flex-col justify-center items-center text-50 md:text-[125px] ${selectedExbtPlcList.includes(hallName) ? 'border-point text-point' : 'border-[#B1B1B1] text-[#B1B1B1]'} `;
    }
    return (<div className='flex flex-col mt-15 md:mt-[37px]'>
        <p className='mt-35 ml-8 font-preBold text-17 md:ml-[20px] md:text-42'>금일 작업하는 곳의 장소를 선택해주세요.</p>
        <p className='ml-8 font-preLight text-15 md:ml-[20px] md:text-37'>(중복 선택 가능)</p>
        <div className='flex justify-between mt-20 mx-20 md:mt-[50px] md:mx-[50px]'>
            <div onClick={() => evntList['전시장1'] && exbtPlcHandler('전시장1', evntList['전시장1'].evntSeq)}
                 className={getPlaceNameProperties('전시장1')}>
                <p className={evntList['전시장1'] ? 'mt-15 text-13 font-preBold whitespace-pre-wrap leading-17 md:text-[32px] md:leading-[42px]' : 'mt-15 text-14 font-preLight whitespace-pre-wrap leading-17 md:text-[35px] md:leading-[42px]'}>
                    {evntList['전시장1'] ? evntList['전시장1'].evntNm.length > 19 ? evntList['전시장1'].evntNm.substring(0, 19) + '..' : evntList['전시장1'].evntNm : noEvntMsg}</p>
                <p>전시장1</p>
            </div>
        </div>
        <div className='flex justify-between mt-20 mx-20 md:mt-[50px] md:mx-[50px]'>
            <div onClick={() => evntList['전시장2'] && exbtPlcHandler('전시장2', evntList['전시장2'].evntSeq)}
                 className={getPlaceNameProperties('전시장2')}>
                <p className={evntList['전시장2'] ? 'mt-15 text-13 font-preBold whitespace-pre-wrap leading-17 md:text-[32px] md:leading-[42px]' : 'mt-15 text-14 font-preLight whitespace-pre-wrap leading-17 md:text-[35px] md:leading-[42px]'}>
                    {evntList['전시장2'] ? evntList['전시장2'].evntNm.length > 19 ? evntList['전시장2'].evntNm.substring(0, 19) + '..' : evntList['전시장2'].evntNm : noEvntMsg}</p>
                <p>전시장2</p>
            </div>
        </div>
    </div>)
};